export interface PartnerConfig {
  name: string
  bannerText: string
  logoClass: string
  bannerClass: string
}

export const PARTNER_CONFIGS: Record<string, PartnerConfig> = {
  aa: {
    name: 'AA',
    bannerText: 'Your AA delivery partner',
    logoClass: 'aa-logo',
    bannerClass: 'aa-banner'
  },
  big_yellow_storage: {
    name: 'Big Yellow Storage',
    bannerText: 'Your Big Yellow delivery partner',
    logoClass: 'big-yellow-logo',
    bannerClass: 'big-yellow-storage-banner'
  },
  safe_store: {
    name: 'SafeStore',
    bannerText: 'Your SafeStore delivery partner',
    logoClass: 'safestore-logo',
    bannerClass: 'safestore-storage-banner'
  },
  access_storage: {
    name: 'Access Self Storage',
    bannerText: 'Your Access Self Storage delivery partner',
    logoClass: 'access-storage-logo',
    bannerClass: 'access-storage-banner'
  },
  uk_storage: {
    name: 'UK Storage',
    bannerText: 'Your UK Storage delivery partner',
    logoClass: 'uk-storage-logo',
    bannerClass: 'uk-storage-banner'
  },
  cinch_storage: {
    name: 'Cinch Self Storage',
    bannerText: 'Your Cinch Self Storage delivery partner',
    logoClass: 'cinch-storage-logo',
    bannerClass: 'cinch-storage-banner'
  }
}

export const SUPPORTED_PARTNERS = Object.keys(PARTNER_CONFIGS)

export const getPartnerConfig = (partnerName: string): PartnerConfig | null => {
  return PARTNER_CONFIGS[partnerName] || null
}

export const getPartnerIdentFromClassName = (className: string): string | null => {
  for (const [partnerIdent, config] of Object.entries(PARTNER_CONFIGS)) {
    if (className.includes(config.bannerClass)) {
      return partnerIdent
    }
  }
  return null
}
